import type { Coordinate } from '@orgsim/shared';
import L from 'leaflet';
import { readTransform } from './transform';

const [a, b, c, d] = readTransform(import.meta.env.VITE_MAP_TRANSFORM);

// GTA world coordinates: lng = x, lat = y. Same setup as gta-v-map-leaflet.
export const gtaCrs: L.CRS = L.extend({}, L.CRS.Simple, {
  transformation: new L.Transformation(a, b, c, d),
});

export const toLatLng = (co: Coordinate): L.LatLng => L.latLng(co.y, co.x);
export const fromLatLng = (ll: L.LatLng): Coordinate => ({
  x: Math.round(ll.lng * 100) / 100,
  y: Math.round(ll.lat * 100) / 100,
});

// The highest zoom level the tile set actually has. Leaflet upscales the last real level
// beyond it instead of requesting tiles that do not exist.
export function maxNativeZoom(): number {
  const raw = Number(import.meta.env.VITE_MAP_MAX_NATIVE_ZOOM);
  return Number.isFinite(raw) && raw > 0 ? raw : 5;
}

export function reliefUrl(): string | null {
  const url = import.meta.env.VITE_MAP_RELIEF_URL as string | undefined;
  return url || null;
}
